import I18n from 'i18n-js';
import React, { useCallback, useState } from 'react';

interface ToggleOptionProps {
  checked: boolean;
  id: string;
  labelClassVariant: string;
  onClick: (id: string) => void;
}

const ToggleOption = ({ checked, id, labelClassVariant, onClick }: ToggleOptionProps) => {
  const onSelect = useCallback(() => {
    onClick(id);
  }, [onClick, id])
  
  return (
    <div className="toggle__option">
      <input type="radio" className="toggle__input" name="community_toggle" id={id} checked={checked} onClick={onSelect} />
      <label className={`toggle__label toggle__label--${labelClassVariant}`} htmlFor={id}>
        {I18n.t(`communities.toggle.${id}`)}
      </label>
    </div>
  )
}

interface CommunityToggleProps {
  checked: string;
}

const CommunityToggle = ({ checked }: CommunityToggleProps) => {
  const [checkedOption, setCheckedOption] = useState(checked);

  const onClick = useCallback((id: string) => {
    setCheckedOption(id);
    const url = new URL(window.location.href);

    url.searchParams.set('type', id);
    url.searchParams.set('page', '1');

    window.location.href = url.href;
  }, [])
  
  return (
    <div className="ranking__title__button">
      <div className="widget">
        <div className="widget__main">
          <div className="toggle">
            <ToggleOption
              id="vendor"
              checked={checkedOption === 'vendor'}
              labelClassVariant="second"
              onClick={onClick}
            />
            <ToggleOption
              id="player"
              checked={checkedOption === 'player'}
              labelClassVariant="first"
              onClick={onClick}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CommunityToggle;